import { useFetchMixAPi1, useMixApi1Toast } from "hooks";
import { getURLWithParams } from "utils/context";

export const useEspecificacoesByPortaria = (id, params = {}) =>
  useFetchMixAPi1(
    id
      ? getURLWithParams(`/legislacao/especificacoes/valores/${id}`, params)
      : null,
  );

export const useProdutosByEsp = (id, params = {}) =>
  useFetchMixAPi1(
    id ? getURLWithParams(`/legislacao/produtos/esp/${id}`, params) : null,
  );

export const useExportValuesPortaria = (id, params = {}) =>
  useFetchMixAPi1(
    id ? getURLWithParams(`/legislacao/portaria/download/${id}`, params) : null,
  );

export const usePortariaDetail = id =>
  useFetchMixAPi1(id ? `/legislacao/portaria/detail/${id}` : null);

export const usePorEspValores = (id, params = {}) =>
  useFetchMixAPi1(
    id
      ? getURLWithParams(
          `/legislacao/especificacaoPortaria/listbyportaria/${id}`,
          params,
        )
      : null,
  );

export const usePortariaToast = (id = null, isModal = false) => {
  const { onSend } = useMixApi1Toast();
  const onCreate = async data => {
    const endpoint = id
      ? `legislacao/portaria/update/${id}`
      : `legislacao/portaria/create`;
    const type = id ? "PUT" : "POST";

    onSend({
      endpoint,
      messageSuccess: id
        ? `Edição realizada com Sucesso`
        : `Portaria Cadastrada com Sucesso`,
      messageFail: id
        ? `Não foi possível realizar edição`
        : `Não foi possível cadastrar a Portaria`,
      data,
      type,
      redirect: id || isModal ? false : true,
      fieldGetId: "mxf_por_id",
      urlRedirect: "/portaria/editar",
    });
  };

  const onRemove = () => {
    const endpoint = `legislacao/portaria/delete/${id}`;
    const type = "DELETE";

    onSend({
      endpoint,
      messageSuccess: `Portaria Removida com Sucesso`,
      messageFail: `Não foi possível remover a Portaria`,
      type,
    });
  };
  return {
    onCreate,
    onRemove,
  };
};
